import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { StateSwitcher } from 'containers/misc'
import { AJ_TRAINING_PROGRESS_STATES } from 'constants/enums'


export default class AjPrepAndTrainingState extends Component {
  static propTypes = {
    awardId: PropTypes.number.isRequired,
    ajPrepAndTrainState: PropTypes.object.isRequired,
    changeAjPrepAndTrainState: PropTypes.func
  }
  static defaultProps = {
    ajPrepAndTrainState: {}
  }

  render() {
    const {
      ajPrepAndTrainState,
      awardId,
      changeAjPrepAndTrainState
    } = this.props

    const states = {
      [AJ_TRAINING_PROGRESS_STATES.ajTrainingInProgress.id]: {
        id: AJ_TRAINING_PROGRESS_STATES.ajTrainingInProgress.id,
        label: 'In Progress',
        intlKey: 'states.in_progress',
        content: null,
        disabledStates: [
          AJ_TRAINING_PROGRESS_STATES.ajTrainingOfficeSignoff.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id
        ]
      },
      [AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id]: {
        id: AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id,
        label: 'Section Authorization',
        intlKey: 'states.leader_signoff',
        content: null,
        disabledStates: [
          AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id
        ]
      },
      [AJ_TRAINING_PROGRESS_STATES.ajTrainingOfficeSignoff.id]: {
        id: AJ_TRAINING_PROGRESS_STATES.ajTrainingOfficeSignoff.id,
        label: 'Award Office Authorization',
        intlKey: 'states.office_signoff',
        content: null,
        disabledStates: [
          AJ_TRAINING_PROGRESS_STATES.ajTrainingInProgress.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id
        ]
      },
      [AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id]: {
        id: AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id,
        label: 'Complete',
        intlKey: 'states.complete',
        content: null,
        disabledStates: [
          AJ_TRAINING_PROGRESS_STATES.ajTrainingInProgress.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingOfficeSignoff.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id
        ]
      },
      [AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id]: {
        id: AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id,
        label: 'Ceremony',
        intlKey: 'states.ceremony',
        content: null,
        disabledStates: [
          AJ_TRAINING_PROGRESS_STATES.ajTrainingInProgress.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingOfficeSignoff.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingCeremony.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id,
          AJ_TRAINING_PROGRESS_STATES.ajTrainingComplete.id
        ]
      }
    }

    return (
      <StateSwitcher
        id={awardId}
        state={ajPrepAndTrainState}
        states={states}
        changeState={changeAjPrepAndTrainState}
      />
    )
  }
}
